/*
 * Liste ekranlarında kolon genişliği (16.10.2026, Burak): kullanıcının sürükleyerek ayarladığı genişlikler ekran
 * (adres) başına tarayıcıda saklanır. Kolon Seçici "Varsayılana dön" bu kaydı da siler.
 */

export const KOLON_EN_DAR = 50;
export const KOLON_EN_GENIS = 900;
/** Ayar yokken içeriğe göre açılan kolonun üst sınırı (CustomCss .kolon-ayarli td ile aynı). */
export const KOLON_VARSAYILAN_TAVAN = 250;

export const kolonGenislikAnahtari = (adres: string) => 'kolon-genislik:' + (adres || '/').toLowerCase();

export const sinirla = (genislik: number) => Math.round(Math.min(KOLON_EN_GENIS, Math.max(KOLON_EN_DAR, genislik)));

/** Kayıtlı genişlikler; kayıt yoksa, bozuksa ya da tarayıcı depolaması kapalıysa boş. */
export const genislikleriOku = (anahtar: string): Record<string, number> => {
    try {
        const ham = localStorage.getItem(anahtar);

        if (!ham)
            return {};

        const veri = JSON.parse(ham);

        if (!veri || typeof veri !== 'object' || Array.isArray(veri))
            return {};

        const sonuc: Record<string, number> = {};

        Object.keys(veri).forEach(k => {
            const n = Number(veri[k]);

            if (isFinite(n) && n > 0)
                sonuc[k] = sinirla(n);
        });

        return sonuc;
    } catch {
        return {};
    }
}

export const genislikKaydet = (anahtar: string, genislikler: Record<string, number>) => {
    try {
        localStorage.setItem(anahtar, JSON.stringify(genislikler));
    } catch {
        // Depolama kapalıysa ayar yalnız bu oturumda geçerli kalır.
    }
}

export const KOLON_SIFIRLA_OLAYI = "kolon-genislik-sifirla";

/** Bu ekranın kayıtlı genişliklerini siler ve açık tabloya haber verir (Kolon Seçici "Sıfırla"). */
export const genislikleriSifirla = () => {
    try {
        localStorage.removeItem(kolonGenislikAnahtari(window.location.pathname));
    } catch {
        // yok say
    }

    window.dispatchEvent(new Event(KOLON_SIFIRLA_OLAYI));
}

/**
 * Çift tıklama: kolonun içeriğe göre genişliği. Başlık ve görünen satırların hücrelerindeki içerik genişliğinin en
 * büyüğü + iç boşluk; sınırlar içinde.
 */
export const otomatikGenislik = (tablo: HTMLTableElement, th: HTMLTableCellElement) => {
    const sira = th.cellIndex;
    let enGenis = th.scrollWidth;

    tablo.querySelectorAll<HTMLTableRowElement>('tbody > tr').forEach(tr => {
        const hucre = tr.cells[sira];

        if (hucre && hucre.colSpan == 1)
            enGenis = Math.max(enGenis, hucre.scrollWidth);
    });

    return sinirla(enGenis + 8);
}
